const PATH = "/api/v2/payment";

const ENDPOINTS = {
  PAYMENT_PROCESS_ORDER: "/process-order/",
  PAYMENT_REFUND_ORDER: "/refund-order/",
  PAYMENT_ORDER_STATUS: "/order-status/",
  PAYMENT_RESPONSE: "/payment-response/",
  PAYMENT_EXCHANGE_CURRENCIES: "/exchange/currencies/",
  PAYMENT_EXCHANGE_RATE: "/exchange/rate/",
};

export type PaymentEndpoints = keyof typeof ENDPOINTS;
export const PaymentCollection = { PATH, ENDPOINTS };
